import NotificationManagementBaseController from '../common/notification_management.base.controller';

class NotificationManagementCreateController extends NotificationManagementBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        super();
        // super(Auth, $state, User, NotificationManagementService, Modal, $translate, $stateParams)
        this.$q = $q;
        this.User = User; 
        this.hasACL = {};

        this.defaultModel = {
            
        };
        this.loading = false;
        this.model = angular.copy(this.defaultModel);
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() { }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }

    submit() { }
}

export default NotificationManagementCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/create/notification_management.create.controller.js